module.exports = __webpack_public_path__ + "img/logo-blue.50d09837.png";